import React from "react";
import {TextField} from "@mui/material";
import {SelectField} from "@atttomyx/react-components";
import {forms, objects} from "@atttomyx/shared-utils";
import {TYPES} from "../../constants";

const UserFilters = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="user-filters">
        <div className="field">
            <TextField
                label="First Name"
                type="text"
                value={forms.sanitizeValue(data.firstName)}
                onChange={(event) => onChange("firstName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Last Name"
                type="text"
                value={forms.sanitizeValue(data.lastName)}
                onChange={(event) => onChange("lastName", event.target.value)}
            />
        </div>
        <div className="field">
            <SelectField
                label="Type"
                value={forms.sanitizeValue(data.type)}
                onChange={(value) => onChange("type", value)}
                options={TYPES}
            />
        </div>
    </div>
}

export default UserFilters;
